import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/skill-assessment/icons/medal.svg'


const _hoisted_1 = { class: "has-text-centered" }
const _hoisted_2 = {
  key: 0,
  class: "is-size-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        class: "mb-5"
      }, null, -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bold-text is-size-4" }, " You Passed! Great Job. ", -1)),
      (_ctx.isRealTechnician)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Your skills request has been sent to the admin. You will be notified when it is approved. "))
        : _createCommentVNode("", true)
    ])
  ], 64))
}